import { useEffect, useState } from "react";
import { bloomAnalyticsApi } from "../../services/bloomAnalyticsApi";
import { Card } from "../../components/common/Card";
import { StatTile } from "../../components/common/StatTile";
import { GapNotice } from "../../components/common/GapNotice";

export function BloomAnalyticsPage() {
  const [coverage, setCoverage] = useState(null);

  useEffect(() => {
    bloomAnalyticsApi.plantCoverage().then(setCoverage).catch(() => setCoverage(null));
  }, []);

  return (
    <div>
      <h1>Bloom Calendar Analytics</h1>
      <p style={{ color: "var(--color-text-muted)" }}>
        app.ForagePlants and app.PlantPhenologyLogs (V013) are real, populated tables (api/functions/blooms.py) --
        every section below just needs a new admin aggregation endpoint, not new schema.
      </p>

      <Card title="Plant Coverage" className="section-spacing">
        {coverage ? (
          <div style={{ display: "flex", gap: "var(--space-3)" }}>
            <StatTile label="Plants in Database" value={coverage.total_plants} />
            <StatTile label="Sites with Bloom Matches" value={coverage.sites_with_matches} />
          </div>
        ) : (
          <GapNotice>Would be COUNT(*) FROM app.ForagePlants plus a distinct site count from app.SiteForageMatches.</GapNotice>
        )}
      </Card>

      <Card title="User Additions" className="section-spacing">
        <GapNotice>Would count app.ForagePlants rows added by users vs. the original seed data, if user-submitted plants are tracked with a created_by column -- worth confirming that column exists before this is buildable as described.</GapNotice>
      </Card>

      <Card title="Phenology Accuracy (User-Reported vs. Predicted)">
        <GapNotice>
          Would compare app.PlantPhenologyLogs' user-submitted actual_bloom_start/actual_bloom_end (logged via
          POST /bloom/observe) against app.SiteForageMatches' predicted bloom_start_date/bloom_end_date for the same
          plant+site -- the data to compare already exists, just no endpoint computing the delta.
        </GapNotice>
      </Card>
    </div>
  );
}
